<template>
  <SchoolsList/>
</template>
<script>
import SchoolsList from '@/components/modules/admin/schools/list'
export default {
  name: 'schools',
  components: {
    SchoolsList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/schools/list.vue